import React, { useEffect, useState } from 'react';

function VisitDataComponent() {
  const [visitData, setVisitData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  let url = "/visit?delete=false";

  let obj = window.location;

  if (typeof obj.hash === "string" && obj.hash.includes("DELETE")) {
    console.log("Hash contains the word DELETE");
    url = "/visit?delete=true";
  } else {
    console.log("Hash does not contain DELETE");
  }

  useEffect(() => {
    fetch(url)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        setVisitData(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  if (loading) return <p>Loading visits...</p>;
  if (error) return <p>Error loading visits: {error}</p>;

  return (
    <div>
      {/* Render your visitData here or pass it down as props */}
      <pre>{JSON.stringify(visitData, null, 2)}</pre>
    </div>
  );
}

export default VisitDataComponent;
